export const API_URL = process.env.REACT_APP_API_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENV;
export const HOSTNAME = process.env.REACT_APP_HOSTNAME || '';
export const LAUNCH_DARKLY_CLIENT_ID = process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID || '';
export const LAUNCH_DARKLY_API_KEY = process.env.REACT_APP_LAUNCH_DARKLY_API_KEY || '';
export const LAUNCH_DARKLY_ENV_KEY = process.env.REACT_APP_LAUNCH_DARKLY_ENV_KEY || '';
export const RELEASE_VERSION = process.env.REACT_APP_RELEASE_VERSION;
